import { keyBy } from 'es-toolkit';
import type { GetDoublingMapParams } from './types';

/**
 * Flags accounts that share the same server-assigned `group` as an earlier-
 * processed balance. The first balance processed per group is kept; every
 * subsequent balance in that group is marked as a duplicate ("doubling") in
 * the returned map, keyed by `accountID`. Accounts without a `group` are
 * never flagged. Duplicate detection intentionally relies on the account's
 * server-assigned `group`, not a token-set comparison, per backend contract.
 */
export const getDoublingMap = ({
  balances = [],
  accounts = [],
}: GetDoublingMapParams): Record<string, boolean> => {
  const resultMap: Record<string, boolean> = {};

  if (!balances?.length || !accounts?.length) {
    return resultMap;
  }

  // One lookup reused for every balance (was an O(n) `find` per balance).
  const accountByName = keyBy(accounts, (account) => account.name);
  const tempMapAll: Record<number, boolean> = {};

  balances.forEach((balance) => {
    const account = accountByName[balance.accountID];

    if (!account || account.group == null) {
      return;
    }

    const dblKey = account.group;

    // we don't use custom check for group, we use server side for duplicates
    if (tempMapAll[dblKey]) {
      resultMap[balance.accountID] = true;
    }

    tempMapAll[dblKey] = true;
  });

  return resultMap;
};
